// @flow
import { select, all, call, fork, put, takeEvery } from 'redux-saga/effects';

import {
    appRedirect,
    appMessageThrow,
    aiSettingsLoaded,
    aiSettingsRequestFailed,
    aiSettingsSaved
} from '../actions';
import {fetchJSON} from "../../helpers/api";
import i18n from '../../i18n';

/**
 * Watch load Ai settings request
 * @returns {IterableIterator<ForkEffect>}
 */
export function* watchAiSettingsLoad(): any {
    yield takeEvery('AI_SETTINGS_LOAD', function*({ payload: { domain_id } }) {
        if (!domain_id) {
            return yield put(aiSettingsLoaded(null));
        }

        try {
            const options = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            };

            const response = yield call(fetchJSON, '/domains/'+domain_id+'/ai-translations/settings', options);
            yield put(aiSettingsLoaded(response));
        } catch (error) {
                console.warn(error);
            if (error.status_code === 404) {
                yield put(appRedirect('/error-404'));
            } else if (error.status_code === 422) {
                yield put(appMessageThrow(error.message, 'warning'));
                yield put(aiSettingsRequestFailed());
            } else {
                yield put(appRedirect('/error-500'));
            }
        }
    });
}

/**
 * Watch user want to save AI settings
 * @returns {IterableIterator<ForkEffect>}
 */
export function* watchAiSettingsSave(): any {
    yield takeEvery('AI_SETTINGS_SAVE', function*({ payload: { domain_id } }) {
        try {

            const state = yield select();
            let settings = JSON.parse(JSON.stringify(state.AiSettings.settings));

            // Do not send the model to the API when it is unset (the backend
            // falls back to the default model), when only one model is
            // available, or when the currently selected model is the default.
            const models = (state.AiModels && state.AiModels.models) || [];
            const enabledModels = models.filter((m) => m.is_enabled !== false);
            const selectedModel = enabledModels.find((m) => m.slug === settings.model);
            if (!settings.model || enabledModels.length === 1 || (selectedModel && selectedModel.is_default)) {
                delete settings.model;
            }

            const options = {
                // body: JSON.stringify(Object.fromEntries(Object.entries(settings).filter(([k, _]) => k != null))),
                body: JSON.stringify(settings),
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            };

            const url = `/domains/${domain_id}/ai-translations/settings`;

            const response = yield call(fetchJSON, url, options);
            yield put(aiSettingsSaved(response));
            let ai_affected_urls = response.ai_affected_urls;
            if (ai_affected_urls !== null) {
               yield put(appMessageThrow(i18n.t('ai_translation.settings.message.save_success', {ai_affected_urls}), 'success'));
            } else {
                yield put(appMessageThrow(i18n.t('ai_translation.settings.message.save_success_only'), 'success'));
            }

        } catch (error) {
            console.warn(error);
            if (error.status_code === 404) {
                yield put(appRedirect('/error-404'));
            } else if (error.status_code === 400) {
                    yield put(appMessageThrow(error.message, 'warning'));
                    yield put(aiSettingsRequestFailed());
            } else {
                yield put(appRedirect('/error-500'));
            }
        }
    });
}

function* AiSettingsSaga(): any {
    yield all([
        fork(watchAiSettingsSave),
        fork(watchAiSettingsLoad),
    ]);
}

export default AiSettingsSaga;
